module.exports = __webpack_public_path__ + "img/icon1-light.81cd1435.png";